var _mask, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPillDarkBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 12,
    viewBox: "0 0 22 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_13150_39995",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.98251 0C2.67846 0 0 2.67846 0 5.98251C0 9.28656 2.67846 11.965 5.98251 11.965H10L10 0H5.98251ZM12 0L12 11.965H16.0175C19.3215 11.965 22 9.28656 22 5.98251C22 2.67846 19.3215 0 16.0175 0H12Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.98251 0C2.67846 0 0 2.67846 0 5.98251C0 9.28656 2.67846 11.965 5.98251 11.965H10L10 0H5.98251ZM12 0L12 11.965H16.0175C19.3215 11.965 22 9.28656 22 5.98251C22 2.67846 19.3215 0 16.0175 0H12Z",
    fill: "#255986"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 11.965V12.965H11V11.965H10ZM10 0L11 7.97052e-08V-1H10V0ZM12 0V-1H11V-7.97052e-08L12 0ZM12 11.965H11V12.965H12V11.965ZM1 5.98251C1 3.23074 3.23075 1 5.98251 1V-1C2.12618 -1 -1 2.12617 -1 5.98251H1ZM5.98251 10.965C3.23075 10.965 1 8.73427 1 5.98251H-1C-1 9.83884 2.12618 12.965 5.98251 12.965V10.965ZM10 10.965H5.98251V12.965H10V10.965ZM11 11.965L11 7.97052e-08L9 -7.97052e-08L9 11.965H11ZM5.98251 1H10V-1H5.98251V1ZM11 -7.97052e-08L11 11.965H13L13 7.97052e-08L11 -7.97052e-08ZM16.0175 10.965H12V12.965H16.0175V10.965ZM21 5.98251C21 8.73427 18.7693 10.965 16.0175 10.965V12.965C19.8738 12.965 23 9.83884 23 5.98251H21ZM16.0175 1C18.7693 1 21 3.23074 21 5.98251H23C23 2.12617 19.8738 -1 16.0175 -1V1ZM12 1H16.0175V-1H12V1Z",
    fill: "#255986",
    mask: "url(#path-1-inside-1_13150_39995)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPillDarkBlue);
export default __webpack_public_path__ + "static/media/pill-dark-blue.3e4c5de80eb8f752dcbb50191c632776.svg";
export { ForwardRef as ReactComponent };